export type LocaleType = 'zh_CN' | 'en_US';

export const LocaleTypeName = {
  zh_CN: '中文',
  en_US: 'English'
};
